/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-14 09:41:39
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PropTypes from 'prop-types'
import s from '../form.css';
import { parseArrayToComplexTable, parseStringToArray } from '../utils';
import classnames from 'classnames';
import { drop, groupBy, head } from 'lodash';
import { getVisual } from '../../../controller';

const defaultColorValue = `
安踏\t #dd3541
李宁\t #00b050
特步\t #ffd70d
耐克\t #0b9796
阿迪达斯\t #adafb4
斐乐\t #03234c
361\t #ea6c05
`;

class FormChart extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    children: PropTypes.node,
  }
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      colorValue: defaultColorValue,
      dataset: [],
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  componentDidMount () {
    this.loadData();
  }

  loadData = () => {
    const { onChange } = this.props;

    getVisual('16_chart').then(value => {
      const _table = FormChart.parse(value);
      const _tempColor = FormChart.parseColor(defaultColorValue);

      this.setState({
        value: value,
        ..._table,
        ..._tempColor
      })
  
      typeof onChange === 'function' && onChange({
        ..._table,
        ..._tempColor
      });
    });
  }

  static parse = (str) => {
    const dataset = parseStringToArray(str);
    if (!dataset) return null;

    return {
      dataset,
      ...FormChart.parseChart(drop(dataset, 1)),
    }
  }

  static parseChart = (arr) => {

    const { columns } = parseArrayToComplexTable(arr);

    const xAxis = drop(head(arr));
    const data = groupBy(arr, ele => ele[0]);
    

    const result = columns.map(({ title }) => ({
      name: title,
      list: data[title].map(ele => {
        const [, name, value] = ele;
        return { name, value };
      })
    }));

    return {
      chartTitle: xAxis,
      chartList: result
    };
  }

  static parseColor = (str) => {
    const chartColorList = parseStringToArray(str);

    return { chartColorList: chartColorList.map(item => item[1]) }
  }

  onChange = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const tableData = FormChart.parse(value, this.state.tableColorList);
    this.setState({ value, ...tableData });

    typeof onChange === 'function' && onChange(tableData)
  }

  onChangeColor = (e) => {
    const { onChange } = this.props;
    const value = e.target.value;
    const _color = FormChart.parseColor(value);

    this.setState({
      colorValue: value,
      ..._color,
    })

    typeof onChange === 'function' && onChange(_color)
  }

  render() {
    return (
      <div className={s.root}>
        <div>数据设置</div>
        <textarea className={classnames(s.inputText)} value={this.state.value} onChange={this.onChange} />
        <div>颜色设置（颜色只和顺序有关）</div>
        <textarea className={classnames(s.inputText)} value={this.state.colorValue} onChange={this.onChangeColor} />
      </div>
    );
  }
}

export default withStyles(s)(FormChart);



// WEBPACK FOOTER //
// src/routes/visualChart/P16/FormChart.js